import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs";

import { AccountService } from "../services/accountService";
import { BaseGuard } from "admin/baseLogin/BaseGuard";

@Injectable()
export class CompanyAuthGuard extends BaseGuard implements CanActivate
{
    constructor(
        protected accountService: AccountService,
        protected router: Router)
    {
        super(accountService, router, "/app/user");
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.CompanyCanActivate(next, state);
    }
}

@Injectable()
export class HasCompanyGuard extends BaseGuard implements CanActivate
{
    constructor(
        protected accountService: AccountService,
        protected router: Router)
    {
        super(accountService, router, "/app/user");
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.HasCompanyCanActivate(next, state);
    }
}
